module.exports = __webpack_public_path__ + "media/components/ramsAnalytics/patterns/hashed-pattern-green-98f98e145a1c6a51d94305ba66557a60.svg";